module.exports = __webpack_public_path__ + "img/tapeInMethod2.0f0a812d.jpg";